/*
 * @Author: Narcissus
 * @Date: 2022-10-25 17:38:02
 * @LastEditTime: 2022-10-31 17:37:58
 * @LastEditors: Narcissus
 * @Description:
 * @FilePath: \hi-tom\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

import layout from '@/layout/index.vue'

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      component: layout,
      redirect: '/',//默认首页
      children: [
        {
          path: '/',
          name: '/',
          component: () => import('@/views/home/index.vue'),
        },
        {
          path: 'mutation',
          name: 'mutation',
          component: () => import('@/views/mutation/index.vue'),
          children: [
            {
              path: 'primer',
              name: 'primer',
              component: () => import('@/views/mutation/components/primer/index.vue'),
            },
            {
              path: 'mutation_detection',
              name: 'mutation_detection',
              component: () => import('@/views/mutation/components/mutation/index.vue'),
            },
            {
              path: 'sequence',
              name: 'sequence',
              component: () => import('@/views/mutation/components/sequence/index.vue'),
            },
          ]
        },
        {
          path: 'dna_methylation',
          name: 'dna_methylation',
          component: () => import('@/views/dna-methylation/index.vue'),
          children: [
            {
              path: 'dna_primer',
              name: 'dna_primer',
              component: () => import('@/views/dna-methylation/components/primer/index.vue'),
            },
            {
              path: 'dna_methylation_detection',
              name: 'dna_methylation_detection',
              component: () => import('@/views/dna-methylation/components/dna/index.vue'),
            },
          ]
        },
        {
          path: 'rare_mutation_detection',
          name: 'rare_mutation_detection',
          component: () => import('@/views/rare_mutation_detection/index.vue'),
        },
        {
          path: 'help',
          name: 'help',
          component: () => import('@/views/help/index.vue'),
        },
        {
          path: 'contact',
          name: 'contact',
          component: () => import('@/views/contact/index.vue'),
        },
      ],
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js